import React, { Component, useEffect, useState } from 'react';
import RegisterView from './RegisterView';
import RegisterVerificationView from './RegisterVerificationView'
import ReceiveMarketingView from './ReceiveMarketingView'
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import crmServices from '../../wsclient/'
import t from '../../utils/translateUtil';
import ModalAlert from '../../components/ModalAlert'
import Loading from '../../components/Loading'
import  { startCountDown}  from "../../utils/util"
import {getAppCfg, getBrowser, getSupportOrderLocation, getRejectTriggerContact, setSupportOrderContact, getCountries, getCountryDefault, getOrderingCountries,getSourceInfo,setSourceInfo, setContacts, getData, getLanguage} from '../../utils/common'
import { connection, domainName, portal_config } from '../../../portal.config';
import { CyprusFlagIcon } from '../../components/icons';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
import TermAndConditionsView from '../more-info/TermAndConditionsView';
import PrivacyPolicyView from '../more-info/PrivacyPolicyView';
import { googleAnalytics, eventTypeSimple } from '../../intergrations/google.analytics';
import { paths } from '../../../portal.router.config';
import { order_key, setOrderCache } from '../../utils/order_cache';

const styles = theme => ({

});
function Register(props){
    const config = getAppCfg()
    const about_details = config && config.about_details ? config && config.about_details: {};
    let agreement_countries = config&&config.contact&&config.contact.agreement_countries?config.contact.agreement_countries:null
    let country_default = null;
    let orderCountries = getOrderingCountries();
    if (connection.crmConfig.useOrderCountry) {
        if(orderCountries.length == 1){ 
            country_default = connection.crmConfig.defaultCountry ? connection.crmConfig.defaultCountry : orderCountries[0].value;
        }else if(orderCountries.length > 1){
            if(connection.crmConfig.defaultCountry){
                let existCountry = orderCountries.filter(x => x.value === connection.crmConfig.defaultCountry);
                if(existCountry && existCountry.length > 0){
                    country_default = existCountry[0];
                }
            }
        }
    } else {
        let configAgreement_countries = config && config.contact && config.contact.agreement_countries ? config.contact.agreement_countries : null
        country_default = getCountryDefault(configAgreement_countries) ? getCountryDefault(configAgreement_countries) : null
    }
    
    const [active, setActive] = useState('main');
    const [error, setError] = useState({});
    const [showLoading, onShowLoading] = useState(false);
    const [register_info, setRegisterInfo] = useState({
                                                country_code: country_default.value,
                                                email_opt_out: false,
                                                sms_opt_out: false,
                                                country_agreement: country_default.value,
                                                email: getSourceInfo() && getSourceInfo().email ? getSourceInfo().email: null,
                                                phone: getSourceInfo() && getSourceInfo().phone ? getSourceInfo().phone: null
                                            });
    const [auth_otp, setAuthOtp] = useState(null);
    const [obfuscated_value, setObfuscatedValue] = useState(null);
    const [validation, setValiadation] = useState({});
    const [countDown, setCountDown] = useState('');
    const [timer_otp, setTimeOTP] = useState({});
    const [country_select, setSelectCountry] = useState(country_default)
    const [accept_policy, setAcceptPolicy] = useState(false);
    const [drawer, setDrawer] = useState({});

    const auth_support = config && config.auth_support ? config.auth_support: {facebook:false, google:false};
    const requestTimer = 30;      

    const onRequestOTP = async(values) => {
        onShowLoading(true);
        let temp_register_info = {...register_info}
        setRegisterInfo(prevState => ({
            ...prevState,
            first_name: values.first_name,
            last_name: values.last_name,
            phone: values.phone,
            referral_code: values.referral_code,
        }));

        temp_register_info.first_name = values.first_name;
        temp_register_info.last_name = values.last_name;
        temp_register_info.phone = values.phone;
        temp_register_info.referral_code = values.referral_code;
        let language_code = getLanguage();
        try {
            let result = await crmServices.contacts.registerByPhone({ ...temp_register_info, password: '123456',language_code });
            if (result.code == 'OK') {
                googleAnalytics.sendLogEvents(eventTypeSimple.sign_up, { method: 'phone'})
                onShowLoading(false);
                beginCountDown()
                if (result.data && result.data.auth_otp) {
                    setAuthOtp(result.data.auth_otp);
                    setObfuscatedValue(result.data.obfuscated_value);
                }
                setActive('verify');
            } else {
                console.log("register by phone exception:", result.code );
                showAlert('ERROR', t(result.code))
            }
        } catch (error) {
            console.log("register by phone exception:", error);
            showAlert('ERROR', t('EXCEPTION_PROCESS'))
        }
        onShowLoading(false);    
    }
    console.log('AAAAA',portal_config[domainName].app_name)
    console.log('AAAAAAAAAAA',register_info.email)
    const onVerifyOTP = async(code) => {
        onShowLoading(true)
        try {
            let result = await crmServices.contacts.validateOTP({ phone: register_info['phone'], auth_otp: auth_otp, otp: code.verification_code });
            if (result.code === 'OK') {
                //crmServices.contacts.addApplicationUsage(config.id,getBrowser().toUpperCase());
                onShowLoading(false);
                setActive('receive_marketing');
                if(!getSupportOrderLocation()&&!getRejectTriggerContact()){
                    
                    let ordering_countries = []
                    if(config.features && config.features.ordering&&config.features.ordering_details&&config.features.ordering_details.ordering_countries){
                        ordering_countries = config.features.ordering_details.ordering_countries
                    }
                    let isAllowOrder = await dataUtil.checkAllowOrderByContact(ordering_countries);
                    if(isAllowOrder){
                        setSupportOrderContact(true)
                    }
                }
                if(portal_config[domainName].app_name=='Dorplay'){
                    try {
                        let update_email=await crmServices.contacts.updateContact({email_address:register_info.email},{});
                        console.log('update email=======',update_email)
                        if(update_email.code==='OK'){
                            console.log('A========',update_email.data)
                        }
                    } catch (error) {
                        console.log('error',error)
                        showAlert('ERROR', t('EXCEPTION_PROCESS'))
                    }
                }
                await checkTriggerFavouriteStore(config)
                // props.history.push('/home');
            } else {
                showAlert('ERROR', t('INVALID_OTP'))
            }
        } catch (error) {
            console.log('error',error)
            showAlert('ERROR', t('EXCEPTION_PROCESS'))
        }
        onShowLoading(false);
    }
    const onResendCode = async() => {
        onShowLoading(true);
        try {
            let result = await crmServices.contacts.sendSMSOTP(register_info['email']);
            if (result.code === 'OK') {
                if (result.data && result.data.auth_otp) {
                    setAuthOtp(result.data.auth_otp)
                }
                showAlert('SUCCESS', t('OTP_RESEND_SUCCESS'))
                beginCountDown();
            } else if(result.code=='TOO_MANY_REQUESTS'){
                showAlert(t('ERROR'), t('TOO_MANY_REQUESTS'));
            } else if(result.code=='TOO_MANY_RECIPIENTS_EXCEPTION'){
                showAlert(t('ERROR'), t('TOO_MANY_RECIPIENTS_EXCEPTION'));
            } else {
                showAlert('ERROR', t('EXCEPTION_PROCESS'))
            }
        } catch (error) {
            showAlert('ERROR', t('EXCEPTION_PROCESS'))
        }
        onShowLoading(false);
    }

    const checkTriggerFavouriteStore = async (appConfig) => {

        // console.log('checkTriggerFavouriteStore router=',router)
        if (!portal_config[domainName].triggerCheckFavouriteStore) {
            // console.log('checkTriggerFavouriteStore route2r=',router)
            onShowLoading(false);
            props.history.push(paths.home);
        } else {
            try {
                var result = await crmServices.contacts.getContactPreferences();
                if (result.code == "OK") {
                    var favouriteStores = result.data && result.data.organisations ? result.data.organisations : [];
                    setOrderCache(order_key.order_favourite_shop, favouriteStores);
                    if (favouriteStores.length == 0) {
                        var result = await crmServices.contacts.getContact();
                        if (result.code === "OK") {
                            setContacts(result.data);
                        }
                        onShowLoading(false);
                        props.history.push(paths.favourite_store);
                    } else {
                        onShowLoading(false);
                        props.history.push(paths.home);
                    }
                } else {
                    onShowLoading(false);
                    props.history.push(paths.home);
                }
            } catch (error) {
                console.log("get preferences exception:", error);
                onShowLoading(false);
                props.history.push(paths.home);
            }
        }
    }

    const onReceiveMarketing = async (target, value) => {
        setRegisterInfo(prevState => ({
            ...prevState,
            [target]: value,
        }));
    }
    const onCancelReceiveMarketing = () =>{
        setActive('home')
        props.history.push('/home');
    }
    const showAlert = (status, message, title) => {
        onShowLoading(false);
        setError({
            showAlert: true,
            title: title,
            message: message,
            status: status})
    }
    const onCloseAlert = () => {
        onShowLoading(false);
        setError({
            showAlert: false,
            title: '',
            message: '',
            status: ''
        })
    }
    const beginCountDown = () => {

        let timerOTP = {
            interval: 1000, //in millisecond - 1 second 
            decreaseVal: 1,
            intervalInstance: undefined
        };
        console.log('Count down timer ', requestTimer);
        timerOTP.fromVal = Number(requestTimer);

        startCountDown(timerOTP, setCountDown,timer_otp);
        setCountDown(timerOTP.fromVal);
        setTimeOTP(timerOTP);
    }
    const onSelectCountry = (key, value) => {
        if(key==='country_code'){
            setRegisterInfo(prevState => ({
                ...prevState,
                [key]: value.value,
            }));
            setSelectCountry(value)
        }
        else{
            setRegisterInfo(prevState => ({
                ...prevState,
                [key]: value.target.value,
            }));
        }
    }
    const onChangeCheckboxPolicy = () => {
        setAcceptPolicy(!accept_policy);
    }
    const onShowDrawer = (target) => {
        let terms_conditions = about_details && about_details.privacy_policy ? about_details.privacy_policy : null;
        let privacy_policy = about_details && about_details.terms_conditions ? about_details.terms_conditions : null;

        if(target === 'terms_conditions'){
            if(terms_conditions && terms_conditions.url){
                window.open(terms_conditions.url, "_blank");
            }else{
                setDrawer({
                    ...drawer,
                    [target]: true,
                });
            }
        }else if(target === 'privacy_policy'){
            if(privacy_policy && privacy_policy.url){
                window.open(privacy_policy.url, "_blank");
            }else{
                setDrawer({
                    ...drawer,
                    [target]: true,
                });
            }
        }else if(target === 'refund_policy'){
            if(document._portalConfig.refundPolicyUrl)
                window.open(document._portalConfig.refundPolicyUrl, "_blank");
        }
    }
    const renderPage = (active) => {
        if(active==='main')
            return(
                <RegisterView
                    onSubmit={onRequestOTP}
                    showAlert={showAlert}
                    onShowLoading={onShowLoading}
                    onReceiveMarketing={onReceiveMarketing}
                    register_info={register_info}
                    onSelectCountry={onSelectCountry}
                    country_select={country_select}
                    auth_support={auth_support}
                    agreement_countries={connection.crmConfig.useOrderCountry ? getOrderingCountries() : getCountries()}
                    country_default={country_default}
                    onChangeCheckboxPolicy={onChangeCheckboxPolicy}
                    accept_policy={accept_policy}
                    onShowDrawer={onShowDrawer}
                />
            )         
        else if(active==='verify'){
            return(
                <RegisterVerificationView
                onSubmit={onVerifyOTP}
                onResend={onResendCode}
                obfuscated_value={obfuscated_value}
                countDown={countDown}/>
            )
        }     

    }

        let page = renderPage(active);
        return (
            <div>
            {page}
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
                title={error.title}
            />
            {drawer && drawer.terms_conditions && 
                <TermAndConditionsView
                    open={drawer.terms_conditions}
                    onCloseItem={() => setDrawer({})}
                    about_details={about_details}  
            />}
            {drawer && drawer.privacy_policy && 
                <PrivacyPolicyView
                    open={drawer.privacy_policy}
                    onCloseItem={() => setDrawer({})}
                    about_details={about_details}
            />}
            {showLoading && <Loading showLoading={showLoading} />}
            </div>

        );
}


export default withStyles(styles)(withTranslation()(Register));